import React, { FC, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { classnames } from '../../../utils/classnames';
import { MenuPortalShortView } from './_ShortView/MenuPortalShortView';
import { MenuPortalSearchView } from './_SearchView/MenuPortalSearchView';
import { MAX_CHILDREN_FOR_SHORT_MODE } from './consts';
import { ISelectMenuPortal } from '../models';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { Popover } from '@src/atoms/Popover';
import { SelectContext } from '../context';

import styled from './SelectMenuPortal.module.scss';
import { getExtraStyles } from '@src/atoms/Select/utils';

export const SelectMenuPortal: FC<ISelectMenuPortal> = (props) => {
  const { children, selectProps, options } = props;
  const optionDefaultLength = useRef(options.length);
  const { controlElement, isGroupedOptions } = useContext(SelectContext);
  const [rect, setWidth] = useState<DOMRect | undefined>();
  const { isMobile } = useContext(BreakpointsContext);
  const { menuPlacement, setMenuMaxWidth } = selectProps;
  const classes = classnames(styled.root, selectProps.classNamePrefix);
  const selectId = selectProps['data-id'];

  const extraStyles = useMemo(() => getExtraStyles(selectProps?.styles?.menuPortal), [selectProps?.styles?.menuPortal]);

  const MobileComponent = useMemo(() => {
    if (isGroupedOptions) {
      const numberOfGroupedOptions = options.reduce((sum, obj) => {
        if (obj.options) {
          return sum + obj.options.length;
        }
        return 0;
      }, 0);
      return numberOfGroupedOptions <= MAX_CHILDREN_FOR_SHORT_MODE ? MenuPortalShortView : MenuPortalSearchView;
    }
    return optionDefaultLength.current <= MAX_CHILDREN_FOR_SHORT_MODE ? MenuPortalShortView : MenuPortalSearchView;
  }, [isGroupedOptions, options]);

  useEffect(() => {
    if (controlElement) {
      setWidth(controlElement.getBoundingClientRect());
    }
  }, [controlElement]);

  if (!controlElement || !rect) return null;

  //ToDo: добавить анимацию появления снизу!
  if (isMobile) {
    return <MobileComponent {...props} data-id={selectId} />;
  }

  return (
    <Popover anchorEl={controlElement} open placement={`${menuPlacement}-start`} className={styled.popover}>
      <div
        style={{
          width: setMenuMaxWidth ? '' : rect.width,
          maxWidth: setMenuMaxWidth ? setMenuMaxWidth : '',
          ...extraStyles,
        }}
        className={classes}
        data-elem="select-menu-portal"
        data-id={`${selectId}_menuWrapper`}
      >
        {children}
      </div>
    </Popover>
  );
};
